import { trackEvent } from "infra/helpers/event";

enum UsuariosEventsEnum {
  ReenviarEmailSenha = "Reenviar_Email_Senha",
}

export function reenviarEmailSenhaEvent(id: string) {
  trackEvent(UsuariosEventsEnum.ReenviarEmailSenha, { id });
}

const UsuariosEvents = {
  reenviarEmailSenhaEvent
};

export default UsuariosEvents;